"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styles_1 = require("@material-ui/core/styles");
var js_cookie_1 = __importDefault(require("js-cookie"));
var ThemeDefaults_1 = __importDefault(require("./ThemeDefaults"));
var DarkThemeDefaults_1 = __importDefault(require("./DarkThemeDefaults"));
var ThemeContext_1 = __importDefault(require("./ThemeContext"));
var deepMerge_1 = require("../utils/deepMerge");
var SPORT_THIEME_DARK_MODE_KEY = 'SPORT_THIEME_DARK_MODE';
function ThemeProvider(_a) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? {} : _b, darkTheme = _a.darkTheme, dark = _a.dark, rest = __rest(_a, ["children", "theme", "darkTheme", "dark"]);
    var _c = react_1.useState(false), darkState = _c[0], setDarkState = _c[1];
    react_1.useEffect(function () {
        var _a;
        var cookieStateDarkMode = js_cookie_1.default.get(SPORT_THIEME_DARK_MODE_KEY);
        var darkMode = (_a = dark !== null && dark !== void 0 ? dark : cookieStateDarkMode) !== null && _a !== void 0 ? _a : window.matchMedia('(prefers-color-scheme)').matches;
        var computedDarkMode = darkMode === true || darkMode === 'true';
        setDarkState(computedDarkMode);
    }, [dark]);
    var setDark = function (state) {
        js_cookie_1.default.set(SPORT_THIEME_DARK_MODE_KEY, state ? 'true' : 'false', {
            expires: 9999,
            domain: process.env.NODE_ENV === 'production' ? '.sport-thieme.io' : window.location.hostname,
        });
        setDarkState(state);
    };
    var toggleDark = function () {
        setDark(!darkState);
    };
    var defaultTheme = darkState ? DarkThemeDefaults_1.default : ThemeDefaults_1.default;
    var givenTheme = darkState && darkTheme !== undefined ? darkTheme : theme;
    var themeObject = deepMerge_1.deepMerge(defaultTheme, givenTheme);
    var muiTheme = styles_1.createMuiTheme(themeObject);
    react_1.useEffect(function () {
        var handleTheDarkness = function (_a) {
            var key = _a.key, shiftKey = _a.shiftKey, ctrlKey = _a.ctrlKey;
            if (key === 'D' && shiftKey && ctrlKey) {
                toggleDark();
            }
        };
        window.addEventListener('keypress', handleTheDarkness);
        return function () { return window.removeEventListener('keypress', handleTheDarkness); };
    }, [toggleDark]);
    react_1.useEffect(function () {
        var preconnect = document.createElement('link');
        preconnect.rel = 'preconnect';
        preconnect.href = 'https://fonts.gstatic.com';
        document.head.append(preconnect);
        var lato = document.createElement('link');
        lato.rel = 'stylesheet';
        lato.href = 'https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap';
        document.head.append(lato);
    }, []);
    return (jsx_runtime_1.jsx(ThemeContext_1.default.Provider, __assign({ value: {
            darkState: [darkState, setDark],
            theme: muiTheme,
        } }, { children: jsx_runtime_1.jsx(styles_1.MuiThemeProvider, __assign({}, rest, { theme: muiTheme }, { children: children }), void 0) }), void 0));
}
exports.default = ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map